import React, { useState } from "react";
import { Button, Drawer, Form, Input, message } from "antd";
import axiosConfig from "../../../util/axiosConfig";
import requestErrorHandler from "../../../util/requestErrorHandler";

const AddMaterial = ({ getMaterials }: any) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  async function handleSubmit() {
    setIsLoading(true);
    await axiosConfig
      .post("/materials/create", form.getFieldsValue())
      .then((response: any) => {
        message.success("Material added successfully");
        form.resetFields();
        setOpen(false);
        getMaterials();
      })
      .catch((error) => {
        requestErrorHandler(error);
      })
      .finally(() => {
        setIsLoading(true);
      });
  }

  return (
    <>
      <Button
        type="primary"
        className="bg-[#096DD9]"
        onClick={() => setOpen(true)}
      >
        Add Material
      </Button>
      <Drawer
        title="Add Material"
        placement="right"
        onClose={() => setOpen(false)}
        open={open}
      >
        <Form
          className="w-100"
          onFinish={handleSubmit}
          form={form}
          layout="vertical"
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: "Enter a valid name" }]}
          >
            <Input />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={isLoading}
            className="bg-[#096DD9]"
          >
            Save
          </Button>
        </Form>
      </Drawer>
    </>
  );
};

export default AddMaterial;
